import { AddCircle, ArrowDropDown, ArrowForward, ArrowRight, Cancel, Check, CheckCircle, ChevronLeft, ChevronRight, Clear, Close, Create, Delete, DeleteOutline, DragHandle, DragIndicator, Edit, Email, Error, ExpandLess, ExpandMore, FileCopy, FileCopyOutlined, FilterList, Fullscreen, FullscreenExit, GridOn, Home, Image, Info, InfoOutlined, KeyboardBackspace, Lens, Link, List, MoreHoriz, NotInterested, PhoneAndroid, PictureAsPdf, PlayArrow, Publish, RadioButtonUnchecked, Refresh, RemoveCircle, Save, SaveAlt, Search, Settings, Stop, SubdirectoryArrowRight, SwapHoriz, SwapVert, ThumbUp, Undo, ViewList, VerticalAlignBottom, Visibility, VisibilityOff, VpnKey, Warning, WatchLater, CloudQueue, CloudCircle, CloudOff, CloudUploadOutlined } from '@mui/icons-material';
import 'react';
import { Catalog } from '../../customIcons/Catalog.js';
import { ClearFilter } from '../../customIcons/ClearFilter.js';
import { Dashboard } from '../../customIcons/Dashboard.js';
import { Export } from '../../customIcons/Export.js';
import { FilterApplied } from '../../customIcons/FilterApplied.js';
import { FormalLetter } from '../../customIcons/FormalLetter.js';
import { FreeForm } from '../../customIcons/FreeForm.js';
import { Relationship } from '../../customIcons/Relationship.js';
import { Table } from '../../customIcons/Table.js';
import { TwoColumn3070 } from '../../customIcons/TwoColumn30-70.js';
import { TwoColumn5050 } from '../../customIcons/TwoColumn50-50.js';
import { AddUnknown } from '../../customIcons/AddUnknown.js';
import { Append } from '../../customIcons/Append.js';
import { DoNotAddUnknown } from '../../customIcons/DoNotAddUnknown.js';
import { DoNotPopulateEmpty } from '../../customIcons/DoNotPopulateEmpty.js';
import { PopulateEmpty } from '../../customIcons/PopulateEmpty.js';
import { Replace } from '../../customIcons/Replace.js';
import '../../customIcons/Map.js';
import { ReferenceNode } from '../../customIcons/ReferenceNode.js';
import { RequiredIcon } from '../../customIcons/RequiredIcon.js';
import { ReadOnly } from '../../customIcons/ReadOnly.js';
import { ArcherDragHandle } from '../../customIcons/ArcherDragHandle.js';
import { Blank } from '../../customIcons/Blank.js';
import { PartialCircle } from '../../customIcons/PartialCircle.js';
import { Queued } from '../../customIcons/Queued.js';
import { Running } from '../../customIcons/Running.js';
var IconList = {
  ArcherDragHandle: ArcherDragHandle,
  AddCircle: AddCircle,
  AddUnknown: AddUnknown,
  Append: Append,
  ArrowDropDown: ArrowDropDown,
  ArrowForward: ArrowForward,
  ArrowRight: ArrowRight,
  Blank: Blank,
  Cancel: Cancel,
  Catalog: Catalog,
  Check: Check,
  CheckCircle: CheckCircle,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  Clear: Clear,
  ClearFilter: ClearFilter,
  Close: Close,
  Create: Create,
  Dashboard: Dashboard,
  Delete: Delete,
  DeleteOutline: DeleteOutline,
  DoNotAddUnknown: DoNotAddUnknown,
  DoNotPopulateEmpty: DoNotPopulateEmpty,
  DragHandle: DragHandle,
  DragIndicator: DragIndicator,
  Edit: Edit,
  Email: Email,
  Error: Error,
  ExpandLess: ExpandLess,
  ExpandMore: ExpandMore,
  Export: Export,
  FileCopy: FileCopy,
  FileCopyOutlined: FileCopyOutlined,
  FilterApplied: FilterApplied,
  FilterList: FilterList,
  FormalLetter: FormalLetter,
  FreeForm: FreeForm,
  Fullscreen: Fullscreen,
  FullscreenExit: FullscreenExit,
  GridOn: GridOn,
  Home: Home,
  Image: Image,
  Info: Info,
  InfoOutlined: InfoOutlined,
  KeyboardBackspace: KeyboardBackspace,
  Lens: Lens,
  Link: Link,
  List: List,
  MoreHoriz: MoreHoriz,
  NotInterested: NotInterested,
  PartialCircle: PartialCircle,
  PhoneAndroid: PhoneAndroid,
  PictureAsPdf: PictureAsPdf,
  PlayArrow: PlayArrow,
  PopulateEmpty: PopulateEmpty,
  Publish: Publish,
  Queued: Queued,
  RadioButtonUnchecked: RadioButtonUnchecked,
  ReferenceNode: ReferenceNode,
  Refresh: Refresh,
  Relationship: Relationship,
  RemoveCircle: RemoveCircle,
  Replace: Replace,
  Running: Running,
  Save: Save,
  SaveAlt: SaveAlt,
  Search: Search,
  Settings: Settings,
  Stop: Stop,
  SubdirectoryArrowRight: SubdirectoryArrowRight,
  SwapHoriz: SwapHoriz,
  SwapVert: SwapVert,
  Table: Table,
  ThumbUp: ThumbUp,
  TwoColumn3070: TwoColumn3070,
  TwoColumn5050: TwoColumn5050,
  Undo: Undo,
  ViewList: ViewList,
  VerticalAlignBottom: VerticalAlignBottom,
  Visibility: Visibility,
  VisibilityOff: VisibilityOff,
  VpnKey: VpnKey,
  Warning: Warning,
  WatchLater: WatchLater,
  // TODO: File Upload Icons (Make sure we need these after the File Upload functionality is verified)
  CloudQueue: CloudQueue,
  CloudCircle: CloudCircle,
  CloudOff: CloudOff,
  CloudUploadOutlined: CloudUploadOutlined,
  RequiredIcon: RequiredIcon,
  ReadOnly: ReadOnly
};
var StatusIconList;

(function (StatusIconList) {
  StatusIconList["CheckCircle"] = "CheckCircle";
  StatusIconList["Error"] = "Error";
  StatusIconList["Queued"] = "Queued";
  StatusIconList["RemoveCircle"] = "RemoveCircle";
  StatusIconList["Warning"] = "Warning";
})(StatusIconList || (StatusIconList = {}));

export { IconList, StatusIconList };